import React from 'react';
import {Link} from 'react-router-dom';
import '../styles/Footer.css';
import NewsletterForm from './NewsletterForm'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFacebook, faLinkedin, faAndroid, faApple} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
    const pages = [
        {path: '/pages/news', label: 'News'},
        {path: '/pages/cinemas', label: 'Cinémas'},
        {path: '/pages/trailers', label: 'Trailers'},
        {path: '/pages/apropos', label: 'À propos'},
        {path: '/pages/cgu', label: 'CGU'},
        {path: '/pages/Confidentialite', label: 'Confidentialité'}
    ];

    return (
        <footer className="site-footer">
            <div className="footer-container">
                {/* Section Informations */}
                <div className="footer-section">
                    <div className="footer-logo">
                        <h2>NaninNan</h2>
                        <p>Votre guide cinéma préféré</p>
                    </div>
                    <div className="contact-info">
                        <p>📞 <a href="tel:+22604443988">+226 04 44 39 88</a></p>
                        <p>✉️ <a href="mailto:info@africadataentry.com">info@africadataentry.com</a></p>
                        <p>📍 <a href="https://maps.app.goo.gl/qd5T2uUzVuSjGcow7" target="_blank"
                                rel="noopener noreferrer">
                            17 BV 30065 OUAGA PISSY 10050 OUAGADOUGOU BURKINA FASO
                        </a></p>
                        <p>🌐 <a href="https://africadataentry.com" target="_blank" rel="noopener noreferrer">
                            ADE WEBSITE
                        </a></p>
                    </div>
                </div>

                {/* Section Navigation */}
                <div className="footer-section">
                    <h3>Navigation</h3>
                    <ul className="footer-links">
                        {pages.map((page) => (
                            <li key={page.path}>
                                <Link to={page.path}>{page.label}</Link>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Section Réseaux Sociaux */}
                <div className="footer-section">
                    <h3>Suivez-nous</h3>
                    <div className="social-icons">
                        <a href="https://www.facebook.com/profile.php?id=61567855461000" aria-label="Facebook"
                           target="_blank" rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faFacebook} className="text-blue-600 text-3xl"/>
                        </a>
                        <a href="https://www.linkedin.com/company/africa-data-entry/" target="_blank"
                           rel="noopener noreferrer">
                            <FontAwesomeIcon icon={faLinkedin} className="text-blue-500 text-3xl"/>
                        </a>
                    </div>
                {/*
                    <h3>Newsletter</h3>
                    <NewsletterForm/>
                    */}
                </div>
                <div className="footer-section">
                <div className="appli-icons">
                    <h3>Bientôt vos application mobile</h3>
                    {/* Icône Android <a href="https://play.google.com" target="_blank" rel="noopener noreferrer">*/}
                    <Link to="/pages/applimobile">

                        <FontAwesomeIcon icon={faAndroid} className="text-green-600 text-3xl"/>

                        {/* Icône iOS https://www.apple.com/app-store/ <a href="https://www.apple.com/app-store/" target="_blank" rel="noopener noreferrer">*/}

                        <FontAwesomeIcon icon={faApple} className="text-gray-800 text-3xl"/>
                    </Link>
                </div>
                </div>

                {/* Section Partenaires */}
                <div className="footer-section">
                    <h3>Nos partenaires</h3>
                    <div className="partners-logos">
                    {/* Section Partenaires
                        <img src="../../images/logo_naninan.png" alt="Partenaire 1"/>
                        <img src="/path/to/partner2.png" alt="Partenaire 2"/>
                        */}
                    </div>
                    <Link to="/pages/partenariat" className="partner-link">
                        Devenir partenaire
                    </Link>
                </div>
            </div>

            {/* Section Droits Légaux */}
            <div className="footer-bottom">
                <p>© {new Date().getFullYear()} Africa Data Entry. Tous droits réservés.</p>
                <div className="legal-links">
                    <Link to="/pages/mentions-legales">Mentions légales</Link>
                    <Link to="/pages/cookies">Politique des cookies</Link>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
